
























import { Component, Vue, Prop } from 'vue-property-decorator';
import SelectPermission from '@/components/selectPermission.vue';
import { sortPermissionsByGroupName } from '@/utils/permission';

type IPermissionInfo = IPermission.IResponse.IPermissionInfo;

@Component({
  components: {
    SelectPermission,
  },
})
export default class EditPermission extends Vue {
  private mode = 'multiple';
  private selectedList: string[] = [];
  private currentPermissions: IPermissionInfo[] = [];
  private loading = false;
  private removedList: string[] = [];
  @Prop({required: true}) private type!: 'add' | 'del';
  @Prop({default: () => []}) private permissions!: IPermissionInfo[];
  @Prop({required: true}) private submitAddPermissions!: (
    permissionIds: string[],
  ) => Promise<string>;
  @Prop({required: true}) private submitDelPermissions!: (
    permissionIds: string[],
  ) => Promise<string>;
  private created() {
    this.resetEdit();
  }
  // 获取当前的PermissionIds
  get currentPermissionIds() {
    return this.currentPermissions.map((permission) => permission.id);
  }
  // 处理选项改变，添加权限
  private handleChange(value: string[]) {
    if (this.mode === 'multiple') {
      this.selectedList = value;
    }
  }
  // 重置编辑数据
  private resetEdit() {
    this.selectedList = [];
    this.removedList = [];
    this.currentPermissions = this.permissions.slice(0);
  }
  // 删除权限
  private removeCurrentPermissions(permissionId: string) {
    const newcurrentPermissions = this.currentPermissions.filter((permission) => permission.id !== permissionId);
    this.currentPermissions = newcurrentPermissions;
    // this.getValue();
    this.removedList.push(permissionId);
  }
  private handleAddPermissions() {
    if (this.selectedList.length <= 0) {
      this.$emit('ok');
      return;
    }
    this.loading = true;
    this.submitAddPermissions(this.selectedList).then((res) => {
      this.$message.success(res);
      this.loading = false;
      this.$emit('ok');
    }).catch((err) => {
      this.loading = false;
      this.$message.warning(err);
    });
  }
  private handleDelPermissions() {
    if (this.removedList.length <= 0) {
      this.$emit('ok');
      return;
    }
    this.loading = true;
    this.submitDelPermissions(this.removedList).then((res) => {
      this.$message.success(res);
      this.loading = false;
      this.$emit('ok');
    }).catch((err) => {
      this.loading = false;
      this.$message.warning(err);
    });
  }
}
